<template>
<w-settings-content-template>
  <el-tabs slot="content" class="content-tap" type="card" v-model="activeTab">
    <el-tab-pane label="로그인/로그아웃 이력" name="userLoginHist" class="h100 w100">
      <w-user-login-hist :active-tab="activeTab"></w-user-login-hist>
    </el-tab-pane>
    <el-tab-pane label="메뉴 접근 이력" name="menuAccessHist" class="h100 w100">
      <w-menu-access-hist :active-tab="activeTab"></w-menu-access-hist>
    </el-tab-pane>
    <el-tab-pane label="장비수행 이력" name="deviceActionHist" class="h100 w100">
      <w-device-action-hist :active-tab="activeTab"></w-device-action-hist>
    </el-tab-pane>
    <el-tab-pane label="설정변경 이력" name="settingChangeHist" class="h100 w100">
      <w-setting-change-hist :active-tab="activeTab"></w-setting-change-hist>
    </el-tab-pane>
  </el-tabs>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WUserLoginHist from './UserLoginHist';
import WMenuAccessHist from './MenuAccessHist';
import WDeviceActionHist from './DeviceActionHist';
import WSettingChangeHist from './SettingChangeHist';

export default {
  name: 'WUserAccessHist',
  components: {
    WSettingsContentTemplate,
    WUserLoginHist,
    WMenuAccessHist,
    WDeviceActionHist,
    WSettingChangeHist,
  },
  data() {
    return {
      activeTab: 'userLoginHist',
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserAccessHist/index.vue